import { render, staticRenderFns } from "./PriceTierModal.vue?vue&type=template&id=9ba1f348&scoped=true&"
import script from "./PriceTierModal.vue?vue&type=script&lang=js&"
export * from "./PriceTierModal.vue?vue&type=script&lang=js&"
import style0 from "./PriceTierModal.vue?vue&type=style&index=0&id=9ba1f348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba1f348",
  null
  
)

component.options.__file = "PriceTierModal.vue"
export default component.exports